import React from 'react';
import { Form, Input, Button, Row, Col, Radio, Checkbox } from 'antd';
import { isEmpty } from 'lodash';

import '../../auth.scss';
import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';
import SpanComponent from '@sharedComponent/span-component';
import ReCAPTCHA from 'react-google-recaptcha';
import { recaptcha } from '@constants';
import { Link } from 'react-router-dom';

const layout = {
	labelCol: { span: 24 },
	wrapperCol: { span: 24 },
};

export const numberOnly = (event) => {
	let number = event.target.value.replace(/[^0-9]/g, '');
	event.target.value = number;
	return number;
};

class RegistrationPresentational extends React.Component {
	componentDidMount() {
		const { userData } = this.props;
		if (!isEmpty(userData)) {
			this.formRef.current.setFieldsValue({
				...userData,
			});
		}
	}
	_reCaptchaRef = React.createRef();

	formRef = React.createRef();

	handleChange = (value) => {
		this.formRef.current.setFieldsValue({
			recaptcha: value,
		});
	};

	onExpired = (value) => {
		this.formRef.current.setFieldsValue({
			recaptcha: value,
		});
	};

	render() {
		const { registerLoading, onFinish, setAgreed, agreed, openTerms, handleValueChange, clearSessionValues } = this.props;
		return (
			<Row>
				<Col md={{ span: 13 }} lg={{ span: 16 }} sm={{ span: 24 }} className="welcome_img">
					<ImageComponent src={images.register} />
				</Col>
				<Col md={{ span: 11 }} lg={{ span: 8 }} sm={{ span: 24 }} className="right_area">
					<Col className="logo_area">
						<ImageComponent src={images.logo_sm} />
					</Col>
					<Col className="sign_in mt-20">
						Register <SpanComponent>Here </SpanComponent>
					</Col>
					<Form
						initialValues={{
							businessName: '',
							url: '',
							accessLevel: 'AFFILIATE',
						}}
						{...layout}
						hideRequiredMark={true}
						layout="vertical"
						ref={this.formRef}
						onFinish={onFinish}
						name="control-ref">
						<Form.Item
							name="accessLevel"
							rules={[
								{
									required: true,
									message: 'Please Select one Account Type !',
								},
							]}>
							<Radio.Group name="accessLevel" onChange={handleValueChange}>
								<Radio value={'AFFILIATE'} defaultChecked={true}>
									Affiliate
								</Radio>
								{/* <Radio disabled value={'MERCHANT'}>
									Merchant
								</Radio> */}
							</Radio.Group>
						</Form.Item>
						<Form.Item
							className="noreq"
							name="email"
							label="E-mail address"
							rules={[
								{
									required: true,
									message: 'Please input your E-mail address!',
								},
								{
									type: 'email',
									message: 'Please input a valid email (Ex: abc@example.com)',
								},
							]}>
							<Input type="email" name="email" onChange={handleValueChange} />
						</Form.Item>
						<Form.Item className="noreq">
							<Row>
								<Col style={{ width: '100%' }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11 }}>
									<Form.Item
										name="firstName"
										label="First Name"
										rules={[
											{
												required: true,
												message: 'Invalid First Name!',
											},
											{
												min: 3,
												message: 'First Name must be atleast 3 characters!',
											},
											{
												pattern: new RegExp(/^[_A-z]*((-|\s)*[_A-z])*$/),
												message: 'First Name cannot contain special characters & numbers',
											},
										]}>
										<Input type="text" name="firstName" onChange={handleValueChange} />
									</Form.Item>
								</Col>
								<Col lg={{ span: 2 }} className="onlyLg"></Col>

								<Col style={{ width: '100%' }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11 }}>
									<Form.Item
										name="lastName"
										label="Last Name"
										rules={[
											{
												required: true,
												message: 'Invalid First Name!',
											},
											{
												pattern: new RegExp(/^[_A-z]*((-|\s)*[_A-z])*$/),
												message: 'First Name cannot contain special characters & numbers',
											},
										]}>
										<Input type="text" name="lastName" onChange={handleValueChange} />
									</Form.Item>
								</Col>
							</Row>
						</Form.Item>
						<Form.Item
							className="bor_bottom"
							name="phone"
							label="Phone Number"
							rules={[
								{
									required: true,
									message: 'Please input your Phone Number!',
								},
								{
									min: 10,
									message: 'Phone Number must be atleast 10 characters',
								},

								{
									max: 10,
									message: 'Phone Number must be maximum 10 characters',
								},
							]}>
							<Input maxLength={10} type="text" className="reg_prefix" prefix={'+1'} name="phone" onChange={handleValueChange} />
						</Form.Item>
						<Col className="tellUs">
							Tell Us About Yourself : <SpanComponent> (Optional) </SpanComponent>{' '}
						</Col>
						<Form.Item className="noreq">
							<Row>
								<Col style={{ width: '100%' }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11 }}>
									<Form.Item
										name="businessName"
										label="Business Name"
										rules={[
											{
												required: false,
												message: 'Please input your Business Name!',
											},
										]}>
										<Input type="text" name="businessName" onChange={handleValueChange} />
									</Form.Item>
								</Col>
								<Col lg={{ span: 2 }} className="onlyLg"></Col>
								<Col style={{ width: '100%' }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11 }}>
									<Form.Item
										name="businessurl"
										label="URL"
										rules={[
											{
												required: false,
												message: 'Please input your URL!',
											},
										]}>
										<Input type="text" name="businessurl" onChange={handleValueChange} />
									</Form.Item>
								</Col>
							</Row>
						</Form.Item>

						<Row>
							<Col lg={{ span: 2 }}></Col>
							<Col lg={{ span: 16 }} md={{ span: 24 }} sm={{ span: 24 }}>
								<Form.Item
									name="recaptcha"
									className="noreq"
									rules={[
										{
											required: true,
											message: 'Please select Recaptcha',
										},
									]}
									style={{ margin: ' 10px 0px' }}>
									<ReCAPTCHA
										style={{ display: 'inline-block' }}
										theme="light"
										type="image"
										onExpired={this.onExpired}
										onChange={this.handleChange}
										ref={this._reCaptchaRef}
										sitekey={recaptcha.siteKey}
									/>
								</Form.Item>
							</Col>
							<Col lg={{ span: 2 }}></Col>
						</Row>

						<Row>
							<Col>
								<Checkbox onChange={(e) => setAgreed(e.target.checked)}>
									By requesting an account, you are agreeing to the{' '}
									<span className="linkText" onClick={openTerms}>
										Terms and Conditions
									</span>{' '}
									for the Konnektive Affiliate Portal.
								</Checkbox>
							</Col>
						</Row>

						<Form.Item style={{ margin: ' 15px 0px' }}>
							<Button className="k_btn" htmlType="submit" loading={registerLoading} disabled={!agreed}>
								Request Access
							</Button>
						</Form.Item>
						<Col className="first_time1">
							Already have an account ?{' '}
							<Link onClick={clearSessionValues} to="/login">
								Login Here
							</Link>
						</Col>
					</Form>
				</Col>
			</Row>
		);
	}
}

export default RegistrationPresentational;
